module.exports = __webpack_public_path__ + "img/ic-docs-tiktok.b39ec49b.svg";